<template>
  <div>
    <p>최종 수정일 :2020년 09월 01일</p>
    <p>
      본 개인정보처리방침은 본 개인정보 처리방침을 참조하는 AILINGGO 웹사이트,
      애플리케이션,제품, 서비스, 이벤트 및 체험 (총칭하여 “AILINGGO
      제반서비스”)과 관련하여 당사가 귀하의 개인정보를 수집하고 이용하는 방법을
      기술하고 있습니다.
    </p>

    <p>
      본 개인정보처리방침은 제 3 자에 의해 제공되는 제품, 서비스, 웹사이트,
      콘텐츠 또는 자체적인 개인정보 처리방침을 보유한 제품, 서비스, 웹사이트,
      콘텐츠 에도 적용되지 않습니다.
    </p>

    <h3>수집 대상 개인정보</h3>
    <p>
      당사는 귀하에게 AILINGGO 제반서비스를 제공하는 과정에서 귀하의 개인정보를
      수집합니다. 당사가 수집하는 개인정보는 다음과 같습니다.
    </p>
    <p>
      • 이름, 닉네임, 사용자 아이디, 인증 및 보안 자격 증명, 전화 번호, 주소,
      이메일 주소, IP주소, 쿠키, 브라우저와 기기의 식별자, 결제 수단
      정보(신용카드 정보 또는 은행계좌 정보), 납세자 등록 번호를 수집하고
      있습니다. 또한, AILINGGO는 부모나 법정대리인의 동의 없이는 14세 미만
      아동의 개인정보를 수집하지 않습니다.
    </p>
    <p>
      • AILINGGO는 귀하가 AILingGo의 제반서비스를 사용함에 있어서 개인정보 외에
      다음과 같은 정보를 자동적으로 수집할 수 있습니다.
    </p>
    <p>
      -방문기록, 파일명, 파일 크기, 파일의 메타데이터, 서비스 사용 기록, 이메일
      및 대화 기록
    </p>

    <h3>개인정보의 이용 방법</h3>
    <p>
      당사는 AILINGGO 제반서비스의 운영, 제공 및 개선을 위하여 귀하의 개인정보를
      이용합니다. 당사의 개인정보 이용목적에는 다음과 같은 사항들이 포함됩니다.
    </p>
    <p>
      • AILINGGO 제반서비스 제공: 당사는 AILINGGO 제반서비스를 제공 및 전달하고
      등록, 구독, 구매 및 지불을 포함한 AILINGGO 제반서비스 관련 거래를 처리하기
      위하여 귀하의 개인정보를 이용합니다. 또한, 귀하와의 커뮤니케이션과 요청에
      응대하기 위해 귀하의 개인정보를 이용하며, 마케팅 및 판촉을 위해 귀하의
      개인정보를 이용합니다. 당사는 귀하의 관심 사항에 기반하여 AILINGGO 제반 서비스 광고를
      표시할 수 있습니다.
    </p>
    <p>
      • AILINGGO 제반서비스 지원 및 개선: 당사는 AILINGGO 제반서비스의 이용
      측정, 성과 분석, 오류 수정, 지원 제공, 서비스 추천, 개선 및 개발을 위하여
      귀하의 개인정보를 이용합니다.
    </p>
    <p>
      • 법적 의무 준수: 당사는 특정 경우에 귀하의 개인정보를 수집, 이용 또는
      보관할 법적 의무를 부담합니다.
    </p>
    <p>
      • 사기와 남용 방지 및 신용 위험: 당사는 당사 고객, AILINGGO 및 타인의
      보안을 보호하기 위하여 사기 및 남용을 방지하고 적발하고자 귀하의
      개인정보를 이용합니다.
    </p>
    <p>
      • 당사가 귀하의 동의를 구하는 목적: 당사는 당사가 귀하에게 통보하는 특정
      목적을 위해 귀하의 개인정보를 이용하는 것에 대한 귀하의 동의를 구할 수
      있습니다.
    </p>
    <h3>쿠키</h3>
    <p>
      당사는 당사 시스템이 귀하의 브라우저 또는 기기를 인식하고 귀하에게
      AILINGGO 제반서비스를 적절하게 제공할 수 있도록 하기 위하여 쿠키를
      이용합니다.
    </p>

    <h3>개인정보의 공유 방법</h3>
    <p>
      당사 고객에 대한 정보는 당사 사업의 중요한 부분이며, 당사는 당사
      고객들의 개인정보를 타인에게 판매하는 사업을 하지 않습니다. 당사는 본
      개인정보 처리방침이 적용되거나 최소한 본 개인정보 처리 방침에 기술된
      사안을 따르는 AILINGGO, Inc. 및 AILINGGO, Inc.의 자회사 또는 자매
      회사와만 오직 아래에 기술된 방식으로 개인정보를 공유합니다.
    </p>
    <p>
      • 제3자가 개입된 거래: 당사는 귀하가 AILINGGO 제반서비스에서 또는 AILINGGO
      제반서비스를 제공하기 위해 제3자가 제공한 서비스, 소프트웨어 및 콘텐츠를
      이용할 수 있도록 합니다. 제3자가 귀하의 거래에 개입된 경우 귀하는 이를 알
      수 있으며, 당사는 제3자와 해당 거래에 관한 일부 정보를 공유합니다.
    </p>
    <p>
      • 제3자 서비스 제공업체: 당사는 당사를 대신하여 일부 기능을 수행하도록
      하기 위하여 기타 회사 및 개인을 고용합니다. 이러한 예로는 지불 처리, 신용
      및 컴플라이언스 위험 평가, 정보 분석, 마케팅 및 판매 지원 제공(광고 및
      이벤트 관리 포함), 고객 관리 및 교육이 포함됩니다. 이러한 제3자 서비스
      제공업체는 그들의 기능을 수행하기 위해 필요한 개인정보에 대한 접근권한이
      있지만 그 외의 목적으로는 개인정보를 이용할 수 없습니다. 더욱이 이들은 본
      개인정보처리방침 및 관련 정보보호법이 허용하는 바에 따라 그들에게 접근이
      허용된 개인정보를 처리해야 합니다.
    </p>
    <p>
      • 귀하의 정보 공유 선택권: 앞서 규정된 경우 외에도 귀하는 귀하의 개인정보가 제3자와
      공유되는 경우 이에 대한 통지를 받게 되며, 정보를 공유하지 않도록 선택할 수
      있습니다.
    </p>
    <h3>개인정보의 위치</h3>
    <p>
      AILINGGO 주식회사는 대한민국에 소재하고 있으며, 귀하의 개인정보는 귀하와
      AILINGGO 제반서비스 간 상호작용의 범위에 따라 대한민국과 미국을 포함한
      다른 국가에 보관되거나 사용될 수 있습니다. 당사가 개인정보를 해외에
      이전할 때마다 당사는 해당 정보가 본 개인정보처리방침 및 관련 정보보호법에
      의해 허용되는 바에 따라 이전되도록 할 것입니다.
    </p>

    <h3>개인정보의 보안 유지 방법</h3>
    <p>
      당사는 귀하의 보안 및 개인정보보호를 염두에 두고 시스템을 설계,
      구성합니다.
    </p>
    <p>
      • 당사는 귀하의 개인정보를 해당 법률에 맞게 수집, 보관 및 사용하고
      있습니다. 필요에 따라서는 암호화하여 수집, 보관 및 사용하여 귀하의
      개인정보를 보호합니다.
    </p>
    <p>
      • 당사는 신용카드 정보 취급 시 지불카드업계 정보보안표준(PCI DSS: Payment Card
      Industry Data Security Standard)을 준수합니다.
    </p>
    <p>
      • 당사는 개인정보의 수집, 보관 및 공개와 관련하여 기술적, 관리적
      보호 조치를 취하고 있습니다.
    </p>
    <h3>인터넷 및 제3자 광고</h3>
    <p>
      AILINGGO 제반서비스는 제3자 광고 및 다른 웹사이트와 애플리케이션으로
      연결되는 링크를 포함할 수 있습니다. 제3자 광고 파트너는 귀하가 동 파트너의
      콘텐츠, 광고 또는 서비스와 상호작용할 때 귀하에 대한 정보를 수집할 수
      있습니다.
    </p>
    <h3>접근 및 선택</h3>
    <p>
      귀하는 귀하의 계정 및 AILINGGO 제반 서비스와의 상호작용에 대한 특정 정보를
      열람, 수정 및 삭제할 수 있습니다. 귀하가 귀하의 정보에 접근하거나 이를
      수정할 수 없는 경우, 언제든지 당사에 연락하여 도움을 요청하실 수 있습니다.
      귀하는 귀하의 개인정보 수집 및 이용에 관한 선택을 할 수 있습니다. 귀하에게는
      특정 정보를 제공하지 않을 선택권이 있으나 이러한 경우, AILINGGO의 특정
      제반서비스 혜택을 받지 못할 수 있습니다.
    </p>
    <h3>아동의 개인정보</h3>
    <p>
      아동은 당사가 제공하는 AILINGGO 제반서비스를 구매할 수 없습니다. 귀하가
      18세 미만인 경우, 부모 또는 보호자의 동의가 있을 때에만 AILINGGO
      제반서비스를 이용할 수 있습니다.
    </p>
    <h3>개인정보의 보유</h3>
    <p>
      당사는 귀하의 지속적인 AILINGGO 제반서비스 이용이 가능하도록 본 개인정보
      처리방침에 기술된 관련 목적을 달성하기 위하여 필요한 기간, 법률이
      요구하는 기간(세무 및 회계 목적을 위해 필요한 기간 포함) 또는 귀하에게
      달리 통지한 기간 동안 귀하의 개인정보를 보유할 수 있습니다. 당사가 특정
      개인정보를 보유하는 기간은 이용 목적에 따라 상이하며, 이후에는 관련 법률에
      따라 귀하의 개인정보를 삭제합니다.
    </p>
    <h3>개인정보보호책임자 및 담당자 안내</h3>
    <p>
      AILINGGO의 개인정보보호에 대한 우려사항이 있거나 당사의 개인정보
      보호책임자 및 담당자에게 문의사항이 있는 경우, 당사에 연락하여 상황을 자세히
      설명해주시면 해결하기 위하여 노력 하겠습니다.
    </p>
    <p>
      개인정보보호책임자 <br />이름: 이재욱 전화: (02) 이메일: cpo@ailinggo.ai
    </p>
    <p>
      개인정보보호 담당자 <br />이름: 이재욱 전화: (02) 이메일: privacy@ailinggo.ai
    </p>
    <p>
      기타 개인 정보 침해에 대한 신고나 상담이 필요한 경우에는 아래 기관에 문의하시기 바랍니다.
    </p>
    <p>개인정보침해신고센터 (http://privacy.kisa.or.kr / 국번없이 118)</p>
    <p>대검찰청 사이버 수사과 (http://www.spo.go.kr / 국번없이 1301)</p>
    <p>
      경찰청 사이버 안전국 (http://police.go.kr / 국번없이 182)
    </p>
    <p>
      당사의 사업이 지속적으로 변화함에 따라 당사의 개인정보처리방침 또한
      변경될 수 있으며, 최신 개인정보처리방침은 당사의 웹사이트를 통해서 수시로
      확인하실 수 있습니다. 달리 명시되어 있지 않은 한, 당사의 개인정보처리방침은
      당사가 귀하 및 귀하의 계정에 관하여 보유하고 있는 모든
      개인정보에 적용됩니다.
    </p>
    <h3>개인정보 추가 정책 (대한민국)</h3>
    <p>
      AILingGo 제반서비스와 관련된 개인정보처리방침과 관련된 추가 정보는 다음과 같습니다.
    </p>
    <h4>개인정보에 대한 이용자의 권리</h4>
    <p>
      고객은 언제든지 AILINGGO 웹 페이지의 ‘내 계정(My Account)’ 메뉴에서
      AILINGGO 계정과 관련한 자신의 개인정보를 조회하거나 수정할 권리를 보유합니다.
      또한, 고객은 계정 종료를 통해 개인정보의 삭제 또는 수집 및
      이용에 관한 동의 철회를 AILINGGO에 요구할 수 있습니다.
    </p>
    <h4>개인정보의 보유 이용 기간</h4>
    <p>
      ∙고객의 개인정보는 AILINGGO와의 비즈니스 관계가 유지되는 동안, 그리고
      AILINGGO의 법적 의무,분쟁 해결 및 계약 시행에 필요한 기간 동안만
      보유됩니다. 또한, AILINGGO는 AILINGGO의 데이터 보존 정책 및 관련 법률에
      따라 고객 개인 정보를 삭제하며, 고객이 계정을 종료한 이후에는, AILINGGO는
      적시에 개인 정보를 삭제하게 됩니다. 그러나 AILINGGO의 법적 의무, 분쟁
      해결 및 계약 이행에 필요한 경우, 또는 법률 규정에 따라 개인 정보를 보관해야
      하는 경우에는 당해 목적을 위하여 필요한 기간 동안 해당 개인정보를 보유합니다.
    </p>
    <h4>개인정보의 삭제</h4>
    <p>
      AILINGGO는 개인 정보 삭제 시, 표준적이며 상업적으로 합리적인 방법으로
      개인 정보를 복구할 수 없거나 재생 불가능하게 합니다. 삭제 방법은 삭제되는
      정보와 고객이 사용하고 있는 AILINGGO 서비스 유형에 따라 다릅니다.
      개인정보가 포함된 전자 문서 또는 파일은 개인정보의 복구 및 검색이 실
      질적으로 불가능하게 하거나 또는 데이터를 더 이상 개인적으로 식별할 수
      없도록 삭제합니다. 비전자 문서또는 개인 정보가 포함된 파일은 파쇄, 파기
      또는 두 가지 방법을 모두 진행하게 됩니다.
    </p>
    <h4>개인정보처리 처리위탁</h4>
    <p>
      AILINGGO는 개인정보처리방침에 규정된 바와 같이 제3자 또는 계열사에
      개인 정보를 제공할 수 있습니다. 모든 개인정보는 AILINGGO 개인정보처리방침,
      비밀 및 보안 요건에 따라 처리됩니다.
    </p>
    <p>
      AILINGGO는 한국에서 AILINGGO와 제휴하여 기능을 수행하는 아래 외부 서비스
      제공업체와 계약관계를 가지고 있으며, 해당 업체는 아래에 기술된 기능을
      수행하는 데 필요한 경우에만 개인정보에 접근할 수 있도록 하고 있습니다.
    </p>
    <table>
      <thead>
        <tr>
          <th>수탁업체</th>
          <th>위탁업무 내용</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Systran</td>
          <td>고객과의 의사 소통</td>
        </tr>
        <tr>
          <td>Salesforce</td>
          <td>고객 관리</td>
        </tr>
        <tr>
          <td>PaymentTech</td>
          <td>결제 수단의 처리</td>
        </tr>
        <tr>
          <td>제너럴에이전트 주식회사</td>
          <td>
            정보통신망 이용촉진 및 정보보호 등에 관한 법률에 따른 국내 대리인
            관련 업무
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <h4>개인정보보호 연락처 안내</h4>
    <p>
      개인정보보호에 관한 문의 및 요청이 있으신 경우, 연락처는 다음과 같습니다.
    </p>
    <p>Data Privacy Officer, AILINGGO, Inc.</p>
    <p>
      E-mail:privacy@allinggo.ai
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.wrapper {
  white-space: pre-line;
}
</style>
